import React, {Component} from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import moment from 'moment';
import {withStyles} from '@material-ui/core/styles';
import ShiftCard from '../parts/ShiftCard';
import ListSubheader from '@material-ui/core/ListSubheader';
import ListItem from '@material-ui/core/ListItem';
import {connect} from 'react-redux';
import {setTitle} from "../state/actions/app";
import PageLoader from "../parts/PageLoader";
import Paper from '@material-ui/core/Paper';
import {withRouter} from "react-router-dom";
import {HashLink as Link} from 'react-router-hash-link';
import Add from '@material-ui/icons/Add';
import Button from '@material-ui/core/Button';
import ShiftModal from "../modals/ShiftDetailsModal";
import CreateShiftModal from '../modals/PostShiftModal';
import ScrollToTopOnMount from "../website-utils/ScrollToTopOnMount";
import iconStand from '../assets/images/icon-stand.png';
import config from "../config";
import WelcomeModal from "../modals/WelcomeModal";
import {fetchManagers} from "../state/actions/managers";
import {fetchBusinessBySlug} from "../state/actions/business";
import {fetchShifts} from "../state/actions/shifts";
import Modal from "../shared/Modal";


class DashboardPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shiftModalOpen: false,
      howItWorksModalOpen: false,
      createShiftModalOpen: false,
      shiftCreatedSnackbarOpen: false,
      welcomeModalOpen: false,
      suppressWelcomeModal: localStorage.getItem('suppressWelcomeModal'),
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let updateState = {};

    if (nextProps.businessIsFetching === false && !nextProps.business) {
      nextProps.history.push(config.routes.notFound);
      return;
    }

    if (nextProps.business) {
      if (!nextProps.shifts) {
        nextProps.fetchShifts(nextProps.business);
      }

      if (!nextProps.managers) {
        nextProps.fetchManagers(nextProps.business);
      }
    }

    if (nextProps.match.params.shiftId) {
      updateState = {
        ...updateState,
        shiftModalOpen: true,
        selectedShift: (nextProps.shifts) ?
          nextProps.shifts.filter(shift => +nextProps.match.params.shiftId === shift.id)[0] : null
      };
    } else if (nextProps.match.params.action === 'create') {
      updateState = {
        ...updateState,
        createShiftModalOpen: true,
      }
    } else {
      updateState = {
        ...updateState,
        shiftModalOpen: false,
        createShiftModalOpen: false,
      }
    }

    return updateState;
  }

  componentDidUpdate(prevProps) {
    if (this.props.shifts !== prevProps.shifts &&
      (this.props.shifts.length === 0 && !this.state.suppressWelcomeModal)
    ) {
      this.openWelcomeModal();
    }
  }

  componentDidMount() {
    window.analytics.page("Business Dashboard", {slug: this.props.match.params.slug});

    this.props.fetchBusinessBySlug(this.props.match.params.slug.toLowerCase());
    this.props.setTitle('Shifts');
  }

  closeShiftModal = () => {
    this.props.history.goBack();
  };

  openCreateShiftModal = () => {
    this.props.history.push(`/${this.props.business.slug}/shifts/create/`)
  };

  closeCreateShiftModal = () => {
    this.props.history.goBack();
  };

  openWelcomeModal = () => {
    this.setState({
      welcomeModalOpen: true,
    });
  };

  closeWelcomeModal = () => {
    this.setState({
      welcomeModalOpen: false,
    });
    localStorage.setItem('suppressWelcomeModal', "true");
    this.openCreateShiftModal();
  };

  createShiftSuccess = () => {
    this.setState({
      shiftCreatedSnackbarOpen: true
    });
  };

  closeShiftCreatedSnackbar = () => {
    this.setState({
      shiftCreatedSnackbarOpen: false
    });
  };

  render() {
    const {classes} = this.props;

    if (!this.props.business || !this.props.shifts) {
      return (
        <PageLoader/>
      );
    }

    const shiftsByCreatedTime = this.props.shifts.sort((a, b) => moment(b.created_time) - moment(a.created_time));

    const shifts = shiftsByCreatedTime.sort((a, b) => moment(b.start_time) - moment(a.start_time));
    console.log(shifts);
    console.log(this.props);

    const upcomingShifts = shifts.filter((shift) => moment(shift.start_time) > Date.now());
    const pastShifts = shifts.filter((shift) => moment(shift.start_time) < Date.now());

    return (
      <div className={classes.content}>
        <ScrollToTopOnMount/>

        {(upcomingShifts.length > 0) ? (
          <List>
            <ListSubheader className={classes.listSubHeader} disableSticky={true}>
              <Typography align='left' variant='subheading'>
                Upcoming Shifts
              </Typography>
            </ListSubheader>
            <ListItem>
              <Grid container spacing={24} className={classes.grid}>
                {upcomingShifts.map((shift, index) => (
                  <Grid item key={index} xs={12} sm={6} lg={4}>
                    <ShiftCard shift={shift}/>
                  </Grid>
                ))}
              </Grid>
            </ListItem>
          </List>
        ) : null}
        {(pastShifts.length > 0) ? (
          <List>
            <ListSubheader className={classes.listSubHeader} disableSticky={true}>
              <Typography align='left' variant='subheading'>
                Past Shifts
              </Typography>
            </ListSubheader>
            <ListItem>
              <Grid container spacing={24} className={classes.grid}>
                {pastShifts.map((shift, index) => (
                  <Grid item key={shift.id} xs={12} sm={6} lg={4}>
                    <ShiftCard shift={shift}/>
                  </Grid>
                ))}
              </Grid>
            </ListItem>
          </List>
        ) : null}
        {(upcomingShifts.length === 0 && pastShifts.length === 0) ? (
          <div className={classes.placeholder}>
            <img className={classes.emptyIcon} src={iconStand}/>
            <Typography variant='headline' className={classes.placeholderHeadline}>No Shifts Posted</Typography>
            <Typography variant='body2'>Post a shift in seconds and schedule a Pro for whenever you need them in the
              next day or week.</Typography>
          </div>
        ) : null}

        {/* Post Shift Button */}
        {/*<Link to={`/${this.props.business.slug}/shifts/create`} style={{outline: 'none'}}>*/}
          {/*<Button variant="raised" color={'primary'} className={classes.createButton}>*/}
            {/*<Add style={{paddingRight: '4px'}}/>*/}
            {/*POST SHIFT*/}
          {/*</Button>*/}
        {/*</Link>*/}

        {/* Welcome Modal */}
        <Modal open={this.state.welcomeModalOpen} className={classes.welcomeModal} onClose={this.closeWelcomeModal}>
          <Paper className={classes.welcomeModalPaper}>
            <WelcomeModal closeModal={this.closeWelcomeModal}/>
          </Paper>
        </Modal>

        {/* Shift Modal Details */}
        <Modal open={this.state.shiftModalOpen}
               onClose={this.closeShiftModal}
               className={classes.modal}>
          <Paper className={classes.paper}>
            <ShiftModal closeShiftModal={this.closeShiftModal} shift={this.state.selectedShift}/>
          </Paper>
        </Modal>

        {/* Create Shift Modal */}
        <Modal open={this.state.createShiftModalOpen}
               className={classes.modal}
               onClose={this.closeCreateShiftModal}>
          <Paper className={classes.paper}>
            <CreateShiftModal
              createShiftSuccess={this.createShiftSuccess}
              closeCreateShiftModal={this.closeCreateShiftModal}/>
          </Paper>
        </Modal>

      </div>
    )
  }
}


const mapStateToProps = (state) => {
  return {
    business: state.business.item,
    businessIsFetching: state.business.isFetching,
    shifts: state.shifts.items,
    managers: state.managers.items,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    setTitle: (title) => dispatch(setTitle(title)),
    fetchBusinessBySlug: (slug) => dispatch(fetchBusinessBySlug(slug)),
    fetchShifts: (business) => dispatch(fetchShifts(business)),
    fetchManagers: (business) => dispatch(fetchManagers(business)),
  }
};

const styles = (theme) => ({
  grid: {
    marginBottom: theme.spacing.unit,
  },
  listSubHeader: {},
  modal: {
    justifyContent: 'flex-end',
    overflow: 'hidden',
  },
  paper: {
    width: '100%',
    position: 'absolute',
    height: '100%',
    right: '0',
    maxWidth: theme.breakpoints.values.sm,
    maxHeight: '100%',
    overflowY: 'scroll',
    overflowScrolling: 'touch',
    WebkitOverflowScrolling: 'touch',
  },
  createButton: {
    position: 'fixed',
    borderRadius: '10em',
    right: theme.spacing.unit * 2,
    bottom: theme.spacing.unit * 2,
    padding: `${theme.spacing.unit}px ${theme.spacing.unit * 3}px ${theme.spacing.unit}px ${theme.spacing.unit * 2}px`,
    outline: 'none',
  },
  content: {
    padding: `${theme.spacing.unit * 2}px 0`,
    background: theme.palette.secondary.main,
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
  },
  placeholder: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'stretch',
    justifyContent: 'center',
    margin: '0 auto 160px',
    width: '80%',
    [theme.breakpoints.up('sm')]: {
      width: '40%',
    },
    [theme.breakpoints.up('md')]: {
      width: '25%',
    },
  },
  placeholderHeadline: {
    marginBottom: theme.spacing.unit,
  },
  emptyIcon: {
    width: '120px',
    margin: '0 auto 18px',
  },
  welcomeModal: {
    justifyContent: 'center',
    alignItems: 'center',
  },
  welcomeModalPaper: {
    width: '90%',
    maxWidth: theme.breakpoints.values.sm,
    maxHeight: '100%',
    overflowY: 'scroll',
    overflowScrolling: 'touch',
    WebkitOverflowScrolling: 'touch',
  },
  banner: {
    borderBottom: '1px solid #cccccc',
    paddingBottom: '12px',
    marginBottom: '12px',
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(withRouter(DashboardPage)));



// WEBPACK FOOTER //
// ./src/pages/DashboardPage.js